import React from 'react';
import { View } from 'react-native';
import { statusTone } from '@hrms/shared';
import { humanize } from '../lib/date';
import { Text } from './Text';
import { radius, toneColors, useTheme, type Tone } from './theme';

export function Badge({ children, tone = 'neutral' }: { children: React.ReactNode; tone?: Tone }) {
  const { colors } = useTheme();
  const t = toneColors(colors, tone);
  return (
    <View style={{ backgroundColor: t.bg, borderRadius: radius.pill, paddingHorizontal: 8, paddingVertical: 2, alignSelf: 'flex-start' }}>
      <Text size={11} weight="semibold" color={t.fg} numberOfLines={1}>
        {children}
      </Text>
    </View>
  );
}

/** Badge coloured by the shared `statusTone()` mapping (approved → success, pending → warning ...). */
export function StatusBadge({ status }: { status: string | null | undefined }) {
  if (!status) return null;
  return <Badge tone={statusTone(status)}>{humanize(status)}</Badge>;
}

export function Dot({ color, size = 8 }: { color: string; size?: number }) {
  return <View style={{ width: size, height: size, borderRadius: size / 2, backgroundColor: color }} />;
}

export function Avatar({ name, size = 32 }: { name: string; size?: number }) {
  const { colors } = useTheme();
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('');
  return (
    <View style={{ width: size, height: size, borderRadius: size / 2, backgroundColor: colors.primarySoft, alignItems: 'center', justifyContent: 'center' }}>
      <Text weight="semibold" color={colors.primary} size={Math.round(size * 0.38)}>
        {initials || '?'}
      </Text>
    </View>
  );
}
